export * from './SimpleModalWrapper.types';
export { default as SimpleModalWrapper } from './SimpleModalWrapper';
